// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

// import Slider from "react-slick";
// import ALine from "../functions/Line";
// import ReactTypingEffect from 'react-typing-effect';

import { useState, useEffect } from 'react';
import { SiThingiverse } from 'react-icons/si';
import { AiFillLinkedin } from 'react-icons/ai';
import { IoHardwareChipOutline } from "react-icons/io5";
import { BsGithub, BsEnvelopeFill, BsSpotify } from 'react-icons/bs';
import { Link } from "react-router-dom"

// import JSON
import homePageJson from '../../configs/home.json';
import aboutPageJson from '../../configs/about.json';

export default function Home() {
    // Scroll to the top on load
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    // Settings for carousel
    // var settings = {
    //     dots: true,
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     swipeToSlide: true,
    //     adaptiveHeight: true,
    //     variableWidth: true,
    // };

    // const [Est, setEst] = useState([])

    return (
        <div className="HomePage">
            <div className="HomePage-ProfileContainer">
                <div className="HomePage-WelcomeMsg-Container-Outer">
                    <div className="HomePage-WelcomeMsg-Container-Inner">
                        <div className="WelcomeMsg">Hello Visitors!</div>
                    </div>
                    <div className="HomePage-WelcomeMsg-Container-Inner Pad-Left">
                        <div className="WelcomeMsg Large">I'm</div>
                        <div className="WelcomeMsg Large Orange">Sin Kiat</div>
                    </div>
                    <div className="HomePage-WelcomeMsg-Container-Inner">
                        <div className="WelcomeMsg Tag">Software Developer</div>
                        <div className="WelcomeMsg Tag">Software Engineer</div>
                        <div className="WelcomeMsg Tag">Electrical Engineer</div>
                        <div className="WelcomeMsg Tag">3D CAD</div>
                    </div>
                    <div className="HomePage-WelcomeMsg-Container-Inner Button">
                        <Link className="WelcomeMsg Medium Button Type1" to="/projects">Projects</Link>
                        <Link className="WelcomeMsg Medium Button Type2" to={homePageJson["RESUMELINK"]["link"]}>Download Resume</Link>
                    </div>
                </div>
                <img alt={homePageJson["PROFILEIMAGE"]["alt"]}
                    className="HomePage-ProfileImage"
                    src={homePageJson["PROFILEIMAGE"]["image"]}
                    loading='lazy' />
            </div>
            
            <div className="fading-line"/>

            <div className="HomePage-About-Container-Outer">
                <div className="HomePage-About-Title">
                    About Me
                </div>
                <div className="HomePage-ProfileContainer aboutSection">
                    <img alt={homePageJson["SUMMARY"]["alt"]} className="HomePage-About-Img" src={aboutPageJson["SUMMARY"]["image"]} />
                    <div className="HomePage-About-Container-Inner">
                        <div className="HomePage-About-Container-Content">
                            <p>{homePageJson["SUMMARY"]["text1"]}</p>
                        </div>
                        <div className="HomePage-About-Container-Contact">
                            {
                                homePageJson["CONNECTION"].map((connectionData, index) => {
                                    return (
                                        <ConnectWM
                                            site={connectionData["site"]}
                                            name={connectionData["name"]}
                                            type={connectionData["type"]}
                                        />
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div className="fading-line"/>

            <div className="HomePage-About-Container-Outer experienceSection">
                <div className="HomePage-About-Title">
                    Experiences
                </div>
                <div className="HomePage-Experience-Container">
                    {
                        homePageJson["EXPERIENCES"].map((connectionData, index) => {
                            return (
                                <ExperienceWM
                                    icon={connectionData["ICON"]}
                                    name={connectionData["NAME"]}
                                    summary={connectionData["SUMMARY"]}
                                />
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
}

function ConnectWM({ site, name, type, ...props }) {
    return (
        <a className="HomePage-Connect-Container-Outer" href={site === undefined ? "/" :site} target="noreferrer">
            <div className="HomePage-Connect-Container-Inner">
                {
                    type === "GITHUB" ? <BsGithub className='HomePage-Connect-Icon' /> :
                        type === "SPOTIFY" ? <BsSpotify className='HomePage-Connect-Icon' /> :
                            type === "MAIL" ? <BsEnvelopeFill className='HomePage-Connect-Icon' /> :
                                type === "LINKEDIN" ? <AiFillLinkedin className='HomePage-Connect-Icon' /> :
                                    type === "THINGIVERSE" ? <SiThingiverse className='HomePage-Connect-Icon' /> :
                                        <></>
                }
                <div className="HomePage-Connect-Item">{name}</div>
            </div>
        </a>
    )
};

function ExperienceWM({ summary, name, icon, ...props }) {
    return (
        <a className="HomePage-Experience-Container-Outer">
            <div className="HomePage-Experience-Container-Inner">
                <img className="HomePage-Connect-Icon" src={icon}/>
                <div className="HomePage-Experience-Item">{name}</div>
                <div className="HomePage-Experience-Summary">{summary}</div>
            </div>
        </a>
    )
};